import { Message } from '../../types';

export const getCurrentTurns = (messages: Message[]) => {
  return Math.ceil(messages.length / 2);
};
